import httpClient from '@/api/httpClient';

// TODO: clarify the endpoint params for save/cancel
const getSettings = () => {
    return httpClient.get('/settings')
        .then(({ data }) => {
            return {
                emailRequiredForExistingCustomer: data.emailRequiredForExistingCustomer,
                emailRequiredForNewCustomer: data.emailRequiredForNewCustomer,
                mobileAppUrl: data.mobileAppUrl,
                onlineAppointmentSchedulerUrl: data.onlineAppointmentSchedulerUrl,
                minInvestmentHorizon: data.minInvestmentHorizon,
                maxInvestmentHorizon: data.maxInvestmentHorizon,
                minInvestmentAmount: data.minInvestmentAmount,
                maxInvestmentAmountViaInput: data.maxInvestmentAmountViaInput,
                maxInvestmentAmountViaSlider: data.maxInvestmentAmountViaSlider,
                infoBoxTimeout: data.infoBoxTimeout,
            };
        });
};

export default {
    getSettings,
};
